/* Find Your Ironclad: vendor wrappers. Every call is try/catch'd and silently no-ops when the
   vendor global is missing (ad blockers). Never logs the email anywhere. window.ICQTrack. */
(function (root) {
  'use strict';
  if (root.ICQTrack) return;

  var KLAVIYO_TIMEOUT = 2500;
  var REVISION = '2025-01-15'; /* single constant for both client endpoints */
  var ALLOWED_PIXEL = '467733848192610';

  function safe(fn) { try { fn(); } catch (e) { /* silent */ } }

  /* POST with a hard timeout. Resolves {ok, status}; never rejects. */
  function post(url, headers, body, timeoutMs) {
    return new Promise(function (resolve) {
      var done = false;
      function finish(ok, status) {
        if (done) return; done = true; resolve({ ok: ok, status: status });
      }
      var timer = setTimeout(function () { finish(false, 'timeout'); }, timeoutMs || KLAVIYO_TIMEOUT);
      try {
        fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body) })
          .then(function (res) { clearTimeout(timer); finish(res.ok, res.status); })
          .catch(function () { clearTimeout(timer); finish(false, 'network'); });
      } catch (e) { clearTimeout(timer); finish(false, 'exception'); }
    });
  }

  function posthog() { return root.posthog; }

  /* PostHog loads after our scripts on some pages (app embed), so load-time events
     (result_viewed, reviews_shown, quiz_viewed) were silently dropped. Queue calls until
     window.posthog.capture exists, then flush in order. Gives up after 20s (ad blockers). */
  var phQueue = [], phTimer = null, phWaited = 0;
  function phReady() { var ph = posthog(); return !!(ph && typeof ph.capture === 'function'); }
  function phFlush() {
    while (phQueue.length) { var job = phQueue.shift(); safe(function () { job(posthog()); }); }
  }
  function phRun(job) {
    if (phReady() && !phQueue.length) { safe(function () { job(posthog()); }); return; }
    phQueue.push(job);
    if (phTimer) return;
    phTimer = setInterval(function () {
      phWaited += 250;
      if (phReady()) { clearInterval(phTimer); phTimer = null; phFlush(); }
      else if (phWaited >= 20000) { clearInterval(phTimer); phTimer = null; phQueue = []; }
    }, 250);
  }

  var T = {
    TIMEOUT: KLAVIYO_TIMEOUT,

    /* Single navigation choke point: previews override this to log instead of leaving. */
    navigate: function (url) { root.location.assign(url); },

    /* PostHog capture. opts.transport = 'sendBeacon' when navigating away. */
    posthog: function (name, props, opts) {
      phRun(function (ph) { ph.capture(name, props || {}, opts || {}); });
    },

    posthogIdentify: function (id, props) {
      phRun(function (ph) { if (typeof ph.identify === 'function') ph.identify(id, props || {}); });
    },

    /* Shopify customer events bus: makes the event visible to web pixels (wetracked et al). */
    shopify: function (name, props) {
      safe(function () {
        var sa = root.Shopify && root.Shopify.analytics;
        if (sa && typeof sa.publish === 'function') sa.publish(name, props || {});
      });
    },

    /* Klaviyo client/profiles upsert. Must land BEFORE the subscription (flow entry filters on market). */
    klaviyoProfile: function (email, firstName, props, companyId) {
      var body = {
        data: {
          type: 'profile',
          attributes: {
            email: email,
            first_name: firstName,
            properties: props
          }
        }
      };
      return post('https://a.klaviyo.com/client/profiles/?company_id=' + (companyId || 'YhV6sQ'),
        { 'revision': REVISION, 'Content-Type': 'application/json' }, body, KLAVIYO_TIMEOUT);
    },

    /* Klaviyo list subscription (single opt-in list, custom source recorded).
       relationships lives INSIDE data, per the subscriptions endpoint schema. */
    klaviyoSubscribe: function (email, firstName, props, listId, companyId) {
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Find Your Ironclad quiz',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  properties: props,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId || 'T3SWtE' } }
          }
        }
      };
      return post('https://a.klaviyo.com/client/subscriptions/?company_id=' + (companyId || 'YhV6sQ'),
        { 'revision': REVISION, 'Content-Type': 'application/json' }, body, KLAVIYO_TIMEOUT);
    },

    klaviyoIdentify: function (email, firstName) {
      safe(function () {
        if (root.klaviyo && typeof root.klaviyo.identify === 'function') {
          root.klaviyo.identify({ email: email, first_name: firstName });
        } else if (root._learnq) {
          root._learnq.push(['identify', { email: email, first_name: firstName }]);
        }
      });
    },

    klaviyoTrack: function (name, props) {
      safe(function () {
        if (root.klaviyo && typeof root.klaviyo.track === 'function') root.klaviyo.track(name, props || {});
        else if (root._learnq) root._learnq.push(['track', name, props || {}]);
      });
    },

    klaviyoTrackViewedItem: function (item) {
      safe(function () {
        if (root.klaviyo && typeof root.klaviyo.trackViewedItem === 'function') {
          root.klaviyo.trackViewedItem(item);
        } else if (root._learnq) root._learnq.push(['trackViewedItem', item]);
      });
    },

    /* Meta browser-pixel Lead. Quiz page ONLY. Hard-fails to a no-op unless the pixel id
       is exactly the allowed one. Never used for PageView/ViewContent/AddToCart/etc. */
    metaLead: function (cfg, email, firstName, route, eventId) {
      if (!cfg || !cfg.metaBrowserLead) return;
      var pixel = String(cfg.metaPixelId || ALLOWED_PIXEL);
      if (pixel !== ALLOWED_PIXEL) return; /* wrong pixel in settings: refuse to fire */
      safe(function () {
        var w = root, d = w.document;
        if (!w.fbq) {
          var n = function () {
            if (n.callMethod) n.callMethod.apply(n, arguments);
            else n.queue.push(arguments);
          };
          n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
          w.fbq = n;
          var s = d.createElement('script');
          s.async = true;
          s.src = 'https://connect.facebook.net/en_US/fbevents.js';
          (d.head || d.documentElement).appendChild(s);
        }
        w.fbq('set', 'autoConfig', false, pixel);
        w.fbq('init', pixel, {
          em: String(email || '').trim().toLowerCase(),
          fn: String(firstName || '').trim().toLowerCase(),
          country: cfg.market
        });
        w.fbq('track', 'Lead', {
          content_name: 'Find Your Ironclad quiz',
          content_category: route,
          value: 0,
          currency: cfg.currency
        }, { eventID: eventId });
      });
    }
  };

  root.ICQTrack = T;
})(typeof window !== 'undefined' ? window : this);
